export class MobileConstants {
  public static readonly MOBILE_WIDTH_BREAKPOINT: string = '(max-width: 1000px)';
}
